export default "__VITE_ASSET__ELbEda7S__"